import axiosInstance from "../axiosInstance/axiosInstance";
import queryClient from "./queryClient";

// Matches the staleTime the bookings list polls with, so a landing decision and
// the list mounting a navigation later share one request instead of two.
export const BOOKINGS_STALE_TIME = 5000;

export const bookingsQueryKey = (userId) => ["bookings", userId];

export const fetchBookings = async (userId) => {
  try {
    const response = await axiosInstance.get(`/api/v1/users/${userId}/bookings`);

    // A guest with no bookings comes back as data:null, and sorting that throws.
    const bookings = response.data.data || [];

    // Sort the bookings by month and day (descending order)
    const sortedBookings = bookings.sort((a, b) => {
      const dateA = new Date(a.checkin_date);
      const dateB = new Date(b.checkin_date);

      // Compare by year first
      if (dateA.getFullYear() === dateB.getFullYear()) {
        // If years are the same, compare by month
        if (dateA.getMonth() === dateB.getMonth()) {
          // If months are also the same, compare by day
          return dateB.getDate() - dateA.getDate(); // Sort by day (most recent first)
        } else {
          return dateB.getMonth() - dateA.getMonth(); // Sort by month (most recent first)
        }
      } else {
        return dateB.getFullYear() - dateA.getFullYear(); // Sort by year (most recent first)
      }
    });

    return sortedBookings;
  } catch (error) {
    console.log(error);
    // Let React Query see the failure, otherwise the query resolves with
    // undefined and it warns instead of reporting the real error
    throw error;
  }
};

// Reads through the cache the bookings list itself uses. The guest who lands
// with no bookings is then known on the list's first render, so the join-by-code
// modal opens on mount rather than after the first poll comes back.
export const loadBookings = (userId) =>
  queryClient.fetchQuery({
    queryKey: bookingsQueryKey(userId),
    queryFn: () => fetchBookings(userId),
    staleTime: BOOKINGS_STALE_TIME,
  });
